import axios from 'axios';
import { ResourceConfig } from '../resourceConfig';
export class GeoResource {
    search(city, street, postalcode) {
        return axios.get(ResourceConfig.mapsURL, {
            params: { city, street, postalcode, format: 'json' }
        });
    }
}
export const geoResource = new GeoResource();
//# sourceMappingURL=geo.resource.js.map